export enum TIPO_COMPROBANTE {
    RESPONSABLE_PAGO = 'ResponsablePago',
    RECEPCION_COMPROBANTE = 'RecepcionComprobante'
}